import { Fragment } from 'react';
import Grid from '@mui/material/Grid';
import CountByAgeCard from '../../../components/dashboard/traffic/CountByAgeCard';
import PopularDemographicsCard from '../../../components/dashboard/traffic/PopularDemographicsCard';
import TrafficByGenderDemographicsCard from '../../../components/dashboard/traffic/TrafficByGenderDemographicsCard';
import TrafficByGenerationDemographicsCard from '../../../components/dashboard/traffic/TrafficByGenerationDemographicsCard';

export default function TrafficAnalyticsByDemographics() {

    return (
        <Fragment>
            <Grid item={true} xs={12} md={12} lg={7} >
                <Grid container={true} spacing={1}>
                    <PopularDemographicsCard />
                    <TrafficByGenderDemographicsCard />
                </Grid>
            </Grid>
            <TrafficByGenerationDemographicsCard />
            <CountByAgeCard />
        </Fragment>
    )
}